import { Notification } from '../notification/Notification';

var options = {
  closable: false,
  style: {right: 10}
};

module.exports = function (notificationData, t) {
  var itemOptions = _.assign({}, options);
  itemOptions.content = (
    <Notification
      t={t}
      type={Notification.TYPES.TYPE_SUCCESS}
      title={t('Upload learners')}
      message={t('The file has been successfully processed.')}
    />
  );

  return itemOptions;
};
